import { Moment } from "moment";
import { SCHEDULER_ROUNDING } from "@sonder/ui/source/styled/components/ScheduleLayer/constants";
import { FilterPair } from "schedule/reducer";

export const areCleaningCompanyIdsActive = ({
  globalFilters,
  localFilters,
}: FilterPair) => {
  return (
    !!localFilters.cleaningCompanyIds &&
    localFilters.cleaningCompanyIds.every(p =>
      globalFilters.cleaningCompanyIds
        ? globalFilters.cleaningCompanyIds.includes(p)
        : false,
    )
  );
};

export const roundTimeDown = (time: Moment) =>
  time.clone().set({
    minutes:
      Math.floor(time.minutes() / SCHEDULER_ROUNDING) * SCHEDULER_ROUNDING,
  });

export const roundTimeUp = (time: Moment) =>
  time.clone().set({
    minutes:
      Math.ceil(time.minutes() / SCHEDULER_ROUNDING) * SCHEDULER_ROUNDING,
  });
